<template>
    <div class="backgroundWrapper rich-bg">
        <div class="listToggle">
            <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item" @click="showTimesBox">
                <div class="nav-link" :class="{ 'active': activeTab === 'thisweek' }" @click="activateTab('thisweek')"
                    data-toggle="tab" href="#thisweek" role="tab">This Week</div>
                </li>
                <li class="nav-item" @click="hideTimesBox">
                <div class="nav-link" :class="{ 'active': activeTab === 'lastweek' }" @click="activateTab('lastweek')"
                    data-toggle="tab" href="#lastweek" role="tab">Last Week</div>
                </li>
            </ul>
            <div class="timesBox" v-show="isTimesBoxVisible">
                <CounterdownCompo :isVisible="true" :showDays="true" />
            </div>
        </div>
        <div class="tab-content">
            <div class="tab-pane" :class="{ 'active': activeTab === 'thisweek' }" id="thisweek" role="tabpanel">
                <div class="tab-contentIn" v-if="isLoadedThisWeek">
                    <RichThisWeekTabCont />
                </div>
            </div>
            <div class="tab-pane" :class="{ 'active': activeTab === 'lastweek' }" id="lastweek" role="tabpanel">
                <div class="tab-contentIn" v-if="isLoadedLastWeek">
                    <RichLastWeekTabCont />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import RichThisWeekTabCont from './RichThisWeekTabCont.vue'
import RichLastWeekTabCont from './RichLastWeekTabCont.vue'
import CounterdownCompo from '../CounterdownCompo.vue';
export default {
    name: 'CompTab',
    components: {
        RichThisWeekTabCont,
        RichLastWeekTabCont,
        CounterdownCompo
    },
    data() {
      return {
        isTimesBoxVisible: true,
        activeTab: 'thisweek', 
        isLoadedThisWeek: false,
        isLoadedLastWeek: false    
      };
    },
    methods: {   
        showTimesBox() {
            this.isTimesBoxVisible = true;
        },
        hideTimesBox() {
            this.isTimesBoxVisible = false;
        },      
        activateTab(tabId) {
            this.activeTab = tabId;
            if(tabId === 'thisweek' && !this.isLoadedThisWeek) {
                this.isLoadedThisWeek = true
            }
            if(tabId === 'lastweek' && !this.isLoadedLastWeek) {
                this.isLoadedLastWeek = true
            }
        },
    },
    mounted() {
        this.isLoadedThisWeek = true
    }
}
</script>